"use strict";

/**
 * Janela de páginas visíveis da paginação.
 *
 * É o mesmo algoritmo do `getVisiblePages` do v2 (`table-pagination-controls.tsx`): até 7 páginas
 * mostra todas; acima disso mostra a primeira, a última, três em volta da atual e reticências no
 * que ficou de fora. Os dois fronts mostram a mesma janela para o mesmo total — que é o ponto de
 * unificar a paginação, e não só de repintá-la.
 *
 * Módulo puro, sem `angular`, para poder ser testado no ambiente `node` do Jest.
 */

export const PAGINATION_ELLIPSIS = "ellipsis";

const MAX_PAGES_WITHOUT_ELLIPSIS = 7;

function range(from, to) {
    const pages = [];
    for (let i = from; i <= to; i++) pages.push(i);
    return pages;
}

export function getVisiblePages(page, totalPages) {
    const total = Number(totalPages);
    if (!Number.isFinite(total) || total < 1) return [];

    const current = Number(page);
    const safePage = Number.isFinite(current) && current > 0 ? current : 1;

    if (total <= MAX_PAGES_WITHOUT_ELLIPSIS) return range(1, total);

    const start = Math.max(1, Math.min(safePage - 1, total - 2));
    const end = Math.min(total, start + 2);
    const pages = [];

    if (start > 1) {
        pages.push(1);
        if (start > 2) pages.push(PAGINATION_ELLIPSIS);
    }

    pages.push(...range(start, end));

    if (end < total) {
        if (end < total - 1) pages.push(PAGINATION_ELLIPSIS);
        pages.push(total);
    }

    return pages;
}
